module.exports = __webpack_public_path__ + "img/midas.4ae104cb.png";